import { gql } from "@apollo/client";


export const GET_NOTIFICATIONS = gql`
query getWebNotifications($todayDate: timestamptz, $pageSize: Int = 10, $pageOffset: Int = 0, $userId: uuid!) {
  past: feed(where: {user_feeds: {uf_deleted_at: {_is_null: true}, uf_is_read: {_eq: false}, u_id: {_eq: $userId}, user: {u_deleted_at: {_is_null: true}, u_is_active: {_eq: true}, _or: [{u_role: {_in: ["admin", "logitix_user"]}}, {u_allowed_roles: {_contains: "affiliater_admin"}}]}}, f_created_at: {_lte: $todayDate}, f_deleted_at: {_is_null: true}}, limit: $pageSize, offset: $pageOffset, order_by: {f_created_at: desc}) {
    f_id
    title: f_title
    type: f_type
    u_id
    tp_id_array
    notification: f_created_at
    user_feeds {
      user {
        userId: u_id
        userName: u_full_name
      }
    }
    ticket_placement {
      tp_id
    }
    ticket {
      t_id
      event {
        eventImage: e_image_url
        eventName: e_name
        eventDate: e_date
        eventAddress: e_address
        eventBrandName: e_brand_name
        eventStatus: e_status
        e_id
      }
    }
  }
  current: feed(where: {user_feeds: {uf_deleted_at: {_is_null: true}, uf_is_read: {_eq: false}, u_id: {_eq: $userId}, user: {u_deleted_at: {_is_null: true}, u_notification_enabled: {_eq: true}, u_is_active: {_eq: true}, _or: [{u_role: {_in: ["admin", "logitix_user"]}}, {u_allowed_roles: {_contains: "affiliater_admin"}}]}}, f_deleted_at: {_is_null: true}}, limit: $pageSize, offset: $pageOffset, order_by: {f_created_at: desc}) {
    f_id
    title: f_title
    type: f_type
    u_id
    tp_id_array
    notification: f_created_at
    user_feeds {
      user {
        userId: u_id
        userName: u_full_name
      }
    }
    ticket_placement {
      tp_id
    }
    ticket {
      t_id
      event {
        eventImage: e_image_url
        eventName: e_name
        eventDate: e_date
        eventAddress: e_address
        eventBrandName: e_brand_name
        eventStatus: e_status
        e_id
      }
    }
  }
  currentCount: feed_aggregate(where: {user_feeds: {uf_deleted_at: {_is_null: true}, uf_is_read: {_eq: false}, u_id: {_eq: $userId}, user: {u_deleted_at: {_is_null: true}, u_notification_enabled: {_eq: true}, u_is_active: {_eq: true}, _or: [{u_role: {_in: ["admin", "logitix_user"]}}, {u_allowed_roles: {_contains: "affiliater_admin"}}]}}, f_deleted_at: {_is_null: true}}, limit: $pageSize, offset: $pageOffset, order_by: {f_created_at: desc}) {
    aggregate {
      count
    }
  }
  pastCount: feed_aggregate(where: {user_feeds: {uf_deleted_at: {_is_null: true}, uf_is_read: {_eq: false}, u_id: {_eq: $userId}, user: {u_deleted_at: {_is_null: true}, u_is_active: {_eq: true}, _or: [{u_role: {_in: ["admin", "logitix_user"]}}, {u_allowed_roles: {_contains: "affiliater_admin"}}]}}, f_created_at: {_lte: $todayDate}, f_deleted_at: {_is_null: true}}, limit: $pageSize, offset: $pageOffset, order_by: {f_created_at: desc}) {
    aggregate {
      count
    }
  }
}
`;


export const CLEAR_ALL_NOTIFICATION = gql`
mutation ClearAllNotification {
  clearallnotification {
    uf_id
    uf_is_read
  }
}
`;

export const UPDATE_READ_STATUS = gql`
mutation UpdateUserFeed ($feedId: uuid!) {
  updateuserfeed(args: {feedid:$feedId}) {
    uf_id
    uf_is_read
  }
}
`;
